module.exports = __webpack_public_path__ + "media/images/landing_page/main_phone-60e8a1b1d1f8aec6585adef7610ef430.webp";